import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { SelectionType } from '../../../shared/enums/selection-type';
import { Webdoku } from '../../../shared/models/webdoku';

@Component({
    selector: 'ldw-web-doku-list-view',
    templateUrl: './web-doku-list-view.component.html',
    styleUrls: ['./web-doku-list-view.component.css'],
    standalone: false
})
export class WebDokuListViewComponent {
  @Input() data?: Webdoku[] = undefined;
  @Output() itemSelected: EventEmitter<SelectionArguments> = new EventEmitter();

  isLoaded(): boolean {
    return this.data != undefined;
  }

  hasData(): boolean {
    return this.data != undefined && this.data.length > 0;
  }

  onSelection(event: any) {
    const selected = event.options[0].value;
    if (selected != undefined) {
      const args = new SelectionArguments();
      args.id = selected;
      args.action = SelectionType.Selected;
      this.itemSelected.emit(args);
    }
  }
}
